import { Alert, Box, Paper, Stack, Modal, Typography } from '@mui/material'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import API from '../../services/API'
import ShiftApplicationPopup from './ShiftApplicationPopup'
import MyUpcomingShifts from './MyUpcomingShifts'
import MyShiftApplications from './MyShiftApplications'
import MyRecentShifts from './MyRecentShifts'
import PagePaper from '../../components/mainFrame/PagePaper'

const MyShifts = () => {
  const [shifts, setShifts] = useState([])
  const [applications, setApplications] = useState([])
  const [recentShifts, setRecentShifts] = useState([])
  const [fetchError, setFetchError] = useState(false)
  const [openShift, setOpenShift] = useState({})

  const loadAvailableShifts = () => {
    API.get('/my-shifts')
      .then((res) => {
        if (res.status === 200) {
          setShifts(res.data.upcomingShifts)
          setApplications(res.data.filteredApplications)
          setRecentShifts(
            [...res.data.recentShifts].sort(
              (a, b) => moment(b.start).valueOf() - moment(a.start).valueOf(),
            ),
          )
        } else {
          setFetchError(true)
        }
      })
      .catch((e) => {
        console.log(e)
        setFetchError(true)
      })
  }
  useEffect(() => {
    loadAvailableShifts()
  }, [])

  const acknowledgeShift = (shiftID) => {
    API.post(`/my-shifts/${shiftID}/acknowledge`).then((res) => {
      if (res.status === 200) loadAvailableShifts()
    })
  }

  const declineShift = (shiftID, reason) => {
    API.post(`/my-shifts/${shiftID}/decline`, { reason }).then((res) => {
      if (res.status === 200) loadAvailableShifts()
    })
  }

  const pendingAcknowledgements = shifts.filter(
    (shift) =>
      shift?.acknowledgement?.required &&
      // On-call shifts never need acknowledgement (covers legacy on-call
      // shifts stamped required before the exemption)
      !shift?.isOnCall &&
      !shift?.acknowledgement?.acknowledgedAt &&
      !shift?.acknowledgement?.declinedAt,
  ).length

  const summaryItems = [
    { label: 'Upcoming', value: shifts.length },
    { label: 'Need Acknowledgement', value: pendingAcknowledgements },
    { label: 'Applications', value: applications.length },
    { label: 'Recent', value: recentShifts.length },
  ]

  return (
    <PagePaper>
      <Stack gap={2}>
        <Stack>
          <Typography variant="title1">My Shifts</Typography>
          <Typography variant="body2" color="text.secondary">
            Confirmed shifts, shift acknowledgements, and shift applications.
          </Typography>
        </Stack>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(2, minmax(0, 1fr))',
              md: 'repeat(4, minmax(0, 1fr))',
            },
            gap: 1,
          }}
        >
          {summaryItems.map((item) => (
            <Paper
              key={item.label}
              variant="outlined"
              sx={{
                p: 1.5,
                borderRadius: 2,
                minHeight: 82,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.25 }}>
                {item.label}
              </Typography>
              <Typography variant="title2" sx={{ lineHeight: 1.15 }}>
                {item.value}
              </Typography>
            </Paper>
          ))}
        </Box>
      {fetchError && (
        <Alert severity="error">
          Unable to fetch your shifts. Please try again later.
        </Alert>
      )}
      <MyUpcomingShifts
        shifts={shifts}
        setOpenShift={setOpenShift}
        acknowledgeShift={acknowledgeShift}
        declineShift={declineShift}
      />

      {recentShifts.length > 0 && (
        <MyRecentShifts
          recentShifts={recentShifts}
          defaultExpanded={!!!shifts.length}
        />
      )}
      {applications.length > 0 && (
        <MyShiftApplications applications={applications} />
      )}
      <Modal
        open={Object.keys(openShift).length > 0}
        onClose={() => setOpenShift({})}
      >
        <>
          <ShiftApplicationPopup
            shift={openShift}
            onClose={() => setOpenShift({})}
            loadAvailableShifts={loadAvailableShifts}
            disableApplication
            shiftConfirmed
          />
        </>
      </Modal>
      </Stack>
    </PagePaper>
  )
}

export default MyShifts
